module.exports = ".upload-btns > button{\n  margin-left: 10px;\n}\n"